import { Injectable } from '@angular/core';
import { TrainingPrice } from './price.model';

@Injectable()
export class TrainingPriceService {
    removeCity(index: number, prices: TrainingPrice[]) {
        prices.splice(index, 1);
    }

    addNewCity(prices: TrainingPrice[]) {
        prices.push(new TrainingPrice());
    }

    setCountry(country: string, item: TrainingPrice): void {
        item.country = country;
    }

    formatTrainingPrices(
        trainingPrices: TrainingPrice[],
        convertToCents: boolean
    ): TrainingPrice[] {
        trainingPrices = trainingPrices.map((trainingPrice: TrainingPrice) => {
            convertToCents
                ? (trainingPrice.price *= 100)
                : (trainingPrice.price /= 100);
            return trainingPrice;
        });

        return trainingPrices;
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/training/location/price.service.ts